"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const common_utils_1 = require("@zapier/common-utils");
const url_utils_1 = require("@zapier/url-utils");
const constants_1 = require("../constants");
const createEditorUrl = ({ flowId, nodeId, pageKey, isTemplate, query, } = {}) => {
    const truthyQuery = lodash_1.default.omitBy(query, common_utils_1.isEmptyString);
    if (query && query.simple) {
        const editorUrl = `/${constants_1.EDITOR_ROUTE_PATH}/${flowId ? flowId : ''}`;
        return url_utils_1.addParamsToUrl(editorUrl, truthyQuery);
    }
    const zapTemplateSegment = isTemplate ? constants_1.ZT_ROUTE_PATH : '';
    const flowSegment = flowId || '';
    const nodeSegment = nodeId ? `nodes/${nodeId}` : '';
    const pageKeySegment = pageKey || '';
    const segments = [
        zapTemplateSegment,
        flowSegment,
        nodeSegment,
        pageKeySegment,
    ]
        .filter(Boolean)
        .join('/');
    const editorUrl = url_utils_1.stripTrailingSlash(`/${constants_1.EDITOR_ROUTE_PATH}/${segments}`);
    return url_utils_1.addParamsToUrl(editorUrl, truthyQuery);
};
exports.default = createEditorUrl;
